import { isUnknownZip } from 'site-modules/shared/utils/location';

/**
 * Determines if a given location's state is excluded from address-to-VIN lookup.
 * Certain states (NY, CA) and unknown zip codes are excluded from this feature.
 *
 * @param {Object} location - The location object containing state and zip information
 * @param {string} location.stateCode - The two-letter state code
 * @returns {boolean} True if the state is excluded or zip is unknown, false otherwise
 */
export const isAddressToVinExcludedState = (location = {}) =>
  ['NY', 'CA'].includes(location.stateCode) || isUnknownZip(location);
